<template>

  <Navbar v-if="$route.name == 'Writer'" />
  <router-view />
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  name: "App",
  components: {
    Navbar,
  },
};
</script>

<style lang="scss">
</style>
